(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("IconButtons", [], factory);
	else if(typeof exports === 'object')
		exports["IconButtons"] = factory();
	else
		root["IconButtons"] = factory();
})(this, function() {
return 